import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import { incomingPostbackLogApi } from "./api";

import GetIncomingPostbackLogsResponse = App.Http.Responses.IncomingPostbackLog.GetIncomingPostbackLogsResponse;
import GetIncomingPostbackLogResponse = App.Http.Responses.IncomingPostbackLog.GetIncomingPostbackLogResponse;
import GetIncomingPostbackLogsRequest = App.Http.Requests.IncomingPostbackLog.GetIncomingPostbackLogsRequest;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

export const useGetIncomingPostbackLogsQuery = (request: GetIncomingPostbackLogsRequest, options = {}) => {
    return useQueryApi<GetIncomingPostbackLogsResponse>({
        queryKey: ["getIncomingPostbackLogs", request],
        queryFn: () => incomingPostbackLogApi.index(request),
        ...options,
    });
};

export const useGetIncomingPostbackLogQuery = (
    logId: string,
    request: { filter?: App.Http.Requests.FilterRequest },
    options = {}
) => {
    return useQueryApi<GetIncomingPostbackLogResponse>({
        queryKey: ["getIncomingPostbackLog", logId, request],
        queryFn: () => incomingPostbackLogApi.show(logId, request),
        ...options,
    });
};

export const useGetIncomingPostbackLogsExportMutation = (
    options: UseMutationOptions<ExportResponse, AxiosError<ApiErrorResponse>, BaseExportRequest> = {}
) => {
    return useMutationApi<ExportResponse, BaseExportRequest>({
        mutationKey: ["getIncomingPostbackLogsExport"],
        mutationFn: (request) => incomingPostbackLogApi.export(request),
        ...options,
    });
};
